import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaypal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 33,
	viewBox: "0 0 32 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .25,
			y: .938477,
			width: 31.5,
			height: 31.5,
			rx: 15.75,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .25,
			y: .938477,
			width: 31.5,
			height: 31.5,
			rx: 15.75,
			stroke: "#E9EAED",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.879 9.4873C14.7142 9.48744 14.5549 9.54632 14.4297 9.65338C14.3045 9.76043 14.2215 9.90863 14.1958 10.0714L13.0605 17.2714C13.1135 16.9351 13.4032 16.6873 13.7438 16.6873H17.0703C20.4182 16.6873 23.2591 14.245 23.7782 10.9353C23.8168 10.6882 23.8387 10.4387 23.8437 10.1887C22.9929 9.74258 21.9934 9.4873 20.8983 9.4873H14.879Z",
			fill: "#00206B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.8432 10.1904C23.8383 10.4405 23.8164 10.6899 23.7777 10.937C23.2586 14.2467 20.4175 16.689 17.0698 16.689H13.7433C13.403 16.689 13.113 16.9366 13.0601 17.2731L12.0163 23.8893L11.3624 28.0399C11.3497 28.1201 11.3545 28.2021 11.3765 28.2803C11.3985 28.3585 11.4372 28.4309 11.4899 28.4927C11.5427 28.5544 11.6082 28.604 11.6819 28.638C11.7557 28.6719 11.8359 28.6895 11.9171 28.6895H15.5278C15.6925 28.6893 15.8518 28.6305 15.9771 28.5234C16.1023 28.4164 16.1852 28.2682 16.211 28.1054L17.1621 22.0733C17.1878 21.9105 17.2709 21.7622 17.3962 21.6551C17.5215 21.5481 17.681 21.4892 17.8458 21.4892H19.9717C23.3196 21.4892 26.1605 19.0469 26.6796 15.7372C27.0482 13.3881 25.8651 11.2505 23.8432 10.1904Z",
			fill: "#009AE0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7765 4.68848C10.4362 4.68848 10.1462 4.936 10.0933 5.27199L7.2599 23.2389C7.20618 23.5799 7.46974 23.8884 7.81509 23.8884H12.0168L13.0601 17.2722L14.1953 10.0722C14.221 9.90945 14.304 9.76125 14.4292 9.65419C14.5545 9.54714 14.7138 9.48826 14.8785 9.48812H20.8978C21.9932 9.48812 22.9924 9.74366 23.8432 10.1895C23.9015 7.17624 21.4151 4.68848 17.9966 4.68848H10.7765Z",
			fill: "#002B8A"
		})
	]
});
export default SvgPaypal;
